"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Cow Location Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.38
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationHeatMapApi = exports.LocationHeatMapApiFactory = exports.LocationHeatMapApiFp = exports.LocationHeatMapApiAxiosParamCreator = exports.GrazingHeatmapMetricsApi = exports.GrazingHeatmapMetricsApiFactory = exports.GrazingHeatmapMetricsApiFp = exports.GrazingHeatmapMetricsApiAxiosParamCreator = exports.GrazingHeatmapApi = exports.GrazingHeatmapApiFactory = exports.GrazingHeatmapApiFp = exports.GrazingHeatmapApiAxiosParamCreator = exports.CowLocationsHealthCheckApi = exports.CowLocationsHealthCheckApiFactory = exports.CowLocationsHealthCheckApiFp = exports.CowLocationsHealthCheckApiAxiosParamCreator = exports.IPolygonDTOTypeEnum = exports.IMultiPolygonDTOTypeEnum = exports.GrazingHeatmapVectorTilesLayerEnum = exports.GenerateHeatMapJobStatusEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.GenerateHeatMapJobStatusEnum = {
    PENDING: 'PENDING',
    READY: 'READY',
    FAILED: 'FAILED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.GrazingHeatmapVectorTilesLayerEnum = {
    H3_INDEXES: 'H3_INDEXES'
};
exports.IMultiPolygonDTOTypeEnum = {
    MULTI_POLYGON: 'MultiPolygon'
};
exports.IPolygonDTOTypeEnum = {
    POLYGON: 'Polygon'
};
/**
 * CowLocationsHealthCheckApi - axios parameter creator
 * @export
 */
var CowLocationsHealthCheckApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cow-locations/healthcheck";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CowLocationsHealthCheckApiAxiosParamCreator = CowLocationsHealthCheckApiAxiosParamCreator;
/**
 * CowLocationsHealthCheckApi - functional programming interface
 * @export
 */
var CowLocationsHealthCheckApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CowLocationsHealthCheckApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.healthCheck(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CowLocationsHealthCheckApiFp = CowLocationsHealthCheckApiFp;
/**
 * CowLocationsHealthCheckApi - factory interface
 * @export
 */
var CowLocationsHealthCheckApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CowLocationsHealthCheckApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck: function (options) {
            return localVarFp.healthCheck(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CowLocationsHealthCheckApiFactory = CowLocationsHealthCheckApiFactory;
/**
 * CowLocationsHealthCheckApi - object-oriented interface
 * @export
 * @class CowLocationsHealthCheckApi
 * @extends {BaseAPI}
 */
var CowLocationsHealthCheckApi = /** @class */ (function (_super) {
    __extends(CowLocationsHealthCheckApi, _super);
    function CowLocationsHealthCheckApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CowLocationsHealthCheckApi
     */
    CowLocationsHealthCheckApi.prototype.healthCheck = function (options) {
        var _this = this;
        return (0, exports.CowLocationsHealthCheckApiFp)(this.configuration).healthCheck(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CowLocationsHealthCheckApi;
}(base_1.BaseAPI));
exports.CowLocationsHealthCheckApi = CowLocationsHealthCheckApi;
/**
 * GrazingHeatmapApi - axios parameter creator
 * @export
 */
var GrazingHeatmapApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Retrieves the grazing heatmap tile found at Z, X, Y coordinate
         * @param {number} z Zoom
         * @param {number} x X coordinate
         * @param {number} y Y coordinate
         * @param {string} [paddockId] Id of paddock to restrict the tiles to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrazingHeatmapTile: function (z, x, y, paddockId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'z' is not null or undefined
                    (0, common_1.assertParamExists)('getGrazingHeatmapTile', 'z', z);
                    // verify required parameter 'x' is not null or undefined
                    (0, common_1.assertParamExists)('getGrazingHeatmapTile', 'x', x);
                    // verify required parameter 'y' is not null or undefined
                    (0, common_1.assertParamExists)('getGrazingHeatmapTile', 'y', y);
                    localVarPath = "/cow-locations/grazing-heatmap/tiles/{z}/{x}/{y}.mvt"
                        .replace("{".concat("z", "}"), encodeURIComponent(String(z)))
                        .replace("{".concat("x", "}"), encodeURIComponent(String(x)))
                        .replace("{".concat("y", "}"), encodeURIComponent(String(y)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paddockId !== undefined) {
                        localVarQueryParameter['paddockId'] = paddockId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Retrieves the tiles configuration for the current farms grazing heatmap
         * @param {string} [paddockId] Id of paddock to restrict the tiles to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrazingHeatmapTilesConfiguration: function (paddockId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cow-locations/grazing-heatmap/tiles/configuration";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paddockId !== undefined) {
                        localVarQueryParameter['paddockId'] = paddockId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.GrazingHeatmapApiAxiosParamCreator = GrazingHeatmapApiAxiosParamCreator;
/**
 * GrazingHeatmapApi - functional programming interface
 * @export
 */
var GrazingHeatmapApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.GrazingHeatmapApiAxiosParamCreator)(configuration);
    return {
        /**
         * Retrieves the grazing heatmap tile found at Z, X, Y coordinate
         * @param {number} z Zoom
         * @param {number} x X coordinate
         * @param {number} y Y coordinate
         * @param {string} [paddockId] Id of paddock to restrict the tiles to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrazingHeatmapTile: function (z, x, y, paddockId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getGrazingHeatmapTile(z, x, y, paddockId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves the tiles configuration for the current farms grazing heatmap
         * @param {string} [paddockId] Id of paddock to restrict the tiles to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrazingHeatmapTilesConfiguration: function (paddockId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getGrazingHeatmapTilesConfiguration(paddockId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.GrazingHeatmapApiFp = GrazingHeatmapApiFp;
/**
 * GrazingHeatmapApi - factory interface
 * @export
 */
var GrazingHeatmapApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.GrazingHeatmapApiFp)(configuration);
    return {
        /**
         * Retrieves the grazing heatmap tile found at Z, X, Y coordinate
         * @param {number} z Zoom
         * @param {number} x X coordinate
         * @param {number} y Y coordinate
         * @param {string} [paddockId] Id of paddock to restrict the tiles to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrazingHeatmapTile: function (z, x, y, paddockId, options) {
            return localVarFp.getGrazingHeatmapTile(z, x, y, paddockId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves the tiles configuration for the current farms grazing heatmap
         * @param {string} [paddockId] Id of paddock to restrict the tiles to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrazingHeatmapTilesConfiguration: function (paddockId, options) {
            return localVarFp.getGrazingHeatmapTilesConfiguration(paddockId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.GrazingHeatmapApiFactory = GrazingHeatmapApiFactory;
/**
 * GrazingHeatmapApi - object-oriented interface
 * @export
 * @class GrazingHeatmapApi
 * @extends {BaseAPI}
 */
var GrazingHeatmapApi = /** @class */ (function (_super) {
    __extends(GrazingHeatmapApi, _super);
    function GrazingHeatmapApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Retrieves the grazing heatmap tile found at Z, X, Y coordinate
     * @param {number} z Zoom
     * @param {number} x X coordinate
     * @param {number} y Y coordinate
     * @param {string} [paddockId] Id of paddock to restrict the tiles to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrazingHeatmapApi
     */
    GrazingHeatmapApi.prototype.getGrazingHeatmapTile = function (z, x, y, paddockId, options) {
        var _this = this;
        return (0, exports.GrazingHeatmapApiFp)(this.configuration).getGrazingHeatmapTile(z, x, y, paddockId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves the tiles configuration for the current farms grazing heatmap
     * @param {string} [paddockId] Id of paddock to restrict the tiles to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrazingHeatmapApi
     */
    GrazingHeatmapApi.prototype.getGrazingHeatmapTilesConfiguration = function (paddockId, options) {
        var _this = this;
        return (0, exports.GrazingHeatmapApiFp)(this.configuration).getGrazingHeatmapTilesConfiguration(paddockId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return GrazingHeatmapApi;
}(base_1.BaseAPI));
exports.GrazingHeatmapApi = GrazingHeatmapApi;
/**
 * GrazingHeatmapMetricsApi - axios parameter creator
 * @export
 */
var GrazingHeatmapMetricsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Retrieves metrics relating to the grazing heatmap for all farms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrazingHeatmapMetricsForAllFarms: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cow-locations/grazing-heatmap/metrics/all-farms";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.GrazingHeatmapMetricsApiAxiosParamCreator = GrazingHeatmapMetricsApiAxiosParamCreator;
/**
 * GrazingHeatmapMetricsApi - functional programming interface
 * @export
 */
var GrazingHeatmapMetricsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.GrazingHeatmapMetricsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Retrieves metrics relating to the grazing heatmap for all farms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrazingHeatmapMetricsForAllFarms: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getGrazingHeatmapMetricsForAllFarms(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.GrazingHeatmapMetricsApiFp = GrazingHeatmapMetricsApiFp;
/**
 * GrazingHeatmapMetricsApi - factory interface
 * @export
 */
var GrazingHeatmapMetricsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.GrazingHeatmapMetricsApiFp)(configuration);
    return {
        /**
         * Retrieves metrics relating to the grazing heatmap for all farms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrazingHeatmapMetricsForAllFarms: function (options) {
            return localVarFp.getGrazingHeatmapMetricsForAllFarms(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.GrazingHeatmapMetricsApiFactory = GrazingHeatmapMetricsApiFactory;
/**
 * GrazingHeatmapMetricsApi - object-oriented interface
 * @export
 * @class GrazingHeatmapMetricsApi
 * @extends {BaseAPI}
 */
var GrazingHeatmapMetricsApi = /** @class */ (function (_super) {
    __extends(GrazingHeatmapMetricsApi, _super);
    function GrazingHeatmapMetricsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Retrieves metrics relating to the grazing heatmap for all farms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrazingHeatmapMetricsApi
     */
    GrazingHeatmapMetricsApi.prototype.getGrazingHeatmapMetricsForAllFarms = function (options) {
        var _this = this;
        return (0, exports.GrazingHeatmapMetricsApiFp)(this.configuration).getGrazingHeatmapMetricsForAllFarms(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return GrazingHeatmapMetricsApi;
}(base_1.BaseAPI));
exports.GrazingHeatmapMetricsApi = GrazingHeatmapMetricsApi;
/**
 * LocationHeatMapApi - axios parameter creator
 * @export
 */
var LocationHeatMapApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Retrieve a heat map
         * @param {string} token Unique identifier of the pre-generated heat map to retrieve
         * @param {number} [resolution] H3 resolution level to use
         * @param {string} [polygons] JSON stringified list of geojson polygons to filter on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLocationHeatMap: function (token, resolution, polygons, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'token' is not null or undefined
                    (0, common_1.assertParamExists)('findLocationHeatMap', 'token', token);
                    localVarPath = "/cow-locations/heat-maps";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (token !== undefined) {
                        localVarQueryParameter['token'] = token;
                    }
                    if (resolution !== undefined) {
                        localVarQueryParameter['resolution'] = resolution;
                    }
                    if (polygons !== undefined) {
                        localVarQueryParameter['polygons'] = polygons;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Retrieve a heat map for a token
         * @param {string} token
         * @param {number} [resolution] H3 resolution level to use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLocationHeatMapForToken: function (token, resolution, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'token' is not null or undefined
                    (0, common_1.assertParamExists)('findLocationHeatMapForToken', 'token', token);
                    localVarPath = "/cow-locations/heat-maps/{token}"
                        .replace("{".concat("token", "}"), encodeURIComponent(String(token)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (resolution !== undefined) {
                        localVarQueryParameter['resolution'] = resolution;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Retrieve job
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLocationHeatMapJob: function (token, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'token' is not null or undefined
                    (0, common_1.assertParamExists)('findLocationHeatMapJob', 'token', token);
                    localVarPath = "/cow-locations/heat-maps/jobs/{token}"
                        .replace("{".concat("token", "}"), encodeURIComponent(String(token)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Asynchronously trigger the job to generate a heat map
         * @param {ITriggerGenerateHeatMapRequestDTO} [iTriggerGenerateHeatMapRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerLocationHeatMapJob: function (iTriggerGenerateHeatMapRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cow-locations/heat-maps/jobs";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iTriggerGenerateHeatMapRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.LocationHeatMapApiAxiosParamCreator = LocationHeatMapApiAxiosParamCreator;
/**
 * LocationHeatMapApi - functional programming interface
 * @export
 */
var LocationHeatMapApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LocationHeatMapApiAxiosParamCreator)(configuration);
    return {
        /**
         * Retrieve a heat map
         * @param {string} token Unique identifier of the pre-generated heat map to retrieve
         * @param {number} [resolution] H3 resolution level to use
         * @param {string} [polygons] JSON stringified list of geojson polygons to filter on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLocationHeatMap: function (token, resolution, polygons, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findLocationHeatMap(token, resolution, polygons, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieve a heat map for a token
         * @param {string} token
         * @param {number} [resolution] H3 resolution level to use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLocationHeatMapForToken: function (token, resolution, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findLocationHeatMapForToken(token, resolution, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieve job
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLocationHeatMapJob: function (token, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findLocationHeatMapJob(token, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Asynchronously trigger the job to generate a heat map
         * @param {ITriggerGenerateHeatMapRequestDTO} [iTriggerGenerateHeatMapRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerLocationHeatMapJob: function (iTriggerGenerateHeatMapRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.triggerLocationHeatMapJob(iTriggerGenerateHeatMapRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.LocationHeatMapApiFp = LocationHeatMapApiFp;
/**
 * LocationHeatMapApi - factory interface
 * @export
 */
var LocationHeatMapApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LocationHeatMapApiFp)(configuration);
    return {
        /**
         * Retrieve a heat map
         * @param {string} token Unique identifier of the pre-generated heat map to retrieve
         * @param {number} [resolution] H3 resolution level to use
         * @param {string} [polygons] JSON stringified list of geojson polygons to filter on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLocationHeatMap: function (token, resolution, polygons, options) {
            return localVarFp.findLocationHeatMap(token, resolution, polygons, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieve a heat map for a token
         * @param {string} token
         * @param {number} [resolution] H3 resolution level to use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLocationHeatMapForToken: function (token, resolution, options) {
            return localVarFp.findLocationHeatMapForToken(token, resolution, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieve job
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLocationHeatMapJob: function (token, options) {
            return localVarFp.findLocationHeatMapJob(token, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Asynchronously trigger the job to generate a heat map
         * @param {ITriggerGenerateHeatMapRequestDTO} [iTriggerGenerateHeatMapRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerLocationHeatMapJob: function (iTriggerGenerateHeatMapRequestDTO, options) {
            return localVarFp.triggerLocationHeatMapJob(iTriggerGenerateHeatMapRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LocationHeatMapApiFactory = LocationHeatMapApiFactory;
/**
 * LocationHeatMapApi - object-oriented interface
 * @export
 * @class LocationHeatMapApi
 * @extends {BaseAPI}
 */
var LocationHeatMapApi = /** @class */ (function (_super) {
    __extends(LocationHeatMapApi, _super);
    function LocationHeatMapApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Retrieve a heat map
     * @param {string} token Unique identifier of the pre-generated heat map to retrieve
     * @param {number} [resolution] H3 resolution level to use
     * @param {string} [polygons] JSON stringified list of geojson polygons to filter on
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHeatMapApi
     */
    LocationHeatMapApi.prototype.findLocationHeatMap = function (token, resolution, polygons, options) {
        var _this = this;
        return (0, exports.LocationHeatMapApiFp)(this.configuration).findLocationHeatMap(token, resolution, polygons, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieve a heat map for a token
     * @param {string} token
     * @param {number} [resolution] H3 resolution level to use
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHeatMapApi
     */
    LocationHeatMapApi.prototype.findLocationHeatMapForToken = function (token, resolution, options) {
        var _this = this;
        return (0, exports.LocationHeatMapApiFp)(this.configuration).findLocationHeatMapForToken(token, resolution, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieve job
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHeatMapApi
     */
    LocationHeatMapApi.prototype.findLocationHeatMapJob = function (token, options) {
        var _this = this;
        return (0, exports.LocationHeatMapApiFp)(this.configuration).findLocationHeatMapJob(token, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Asynchronously trigger the job to generate a heat map
     * @param {ITriggerGenerateHeatMapRequestDTO} [iTriggerGenerateHeatMapRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHeatMapApi
     */
    LocationHeatMapApi.prototype.triggerLocationHeatMapJob = function (iTriggerGenerateHeatMapRequestDTO, options) {
        var _this = this;
        return (0, exports.LocationHeatMapApiFp)(this.configuration).triggerLocationHeatMapJob(iTriggerGenerateHeatMapRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LocationHeatMapApi;
}(base_1.BaseAPI));
exports.LocationHeatMapApi = LocationHeatMapApi;
